import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_tax_rule",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body pt-10 pb-5 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "row align-items-end g-9" }
const _hoisted_9 = { class: "col-md-9 fv-row " }
const _hoisted_10 = { class: "col-md-3 fv-row " }
const _hoisted_11 = { class: "grid-content bg-purple" }
const _hoisted_12 = {
  class: "d-flex flex-stack fs-6 fw-bold mb-1",
  "data-v-9d4a844a": ""
}
const _hoisted_13 = {
  class: "symbol symbol-50px me-6",
  "data-v-9d4a844a": ""
}
const _hoisted_14 = {
  class: "d-flex flex-column",
  "data-v-9d4a844a": ""
}
const _hoisted_15 = {
  class: "fs-6",
  "data-v-9d4a844a": ""
}
const _hoisted_16 = {
  class: "fs-7 text-muted",
  "data-v-9d4a844a": ""
}
const _hoisted_17 = { class: "modal-footer flex-center" }
const _hoisted_18 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_19 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.taxRuleData,
          ref: "taxRuleForm"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t('message.ADD')} ${_ctx.$t('message.TAX')} ${_ctx.$t('message.RULES')} `), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_Input, {
                      type: "text",
                      name: "name",
                      label: `${_ctx.$t('message.NAME')} (${_ctx.locale})`,
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                      requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
                      "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.taxRuleData.name = $event)),
                      target: "name",
                      required: true,
                      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateValue(_ctx.taxRuleData.name))),
                      value: _ctx.taxRuleData.name
                    }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_Select, {
                      name: "locale",
                      target: "locale",
                      callEmit: true,
                      required: false,
                      label: false,
                      locale: _ctx.locale,
                      "onUpdate:locale": _cache[3] || (_cache[3] = ($event: any) => (_ctx.locale = $event)),
                      selectData: _ctx.locales,
                      value: _ctx.locale,
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeLang(_ctx.locale)))
                    }, null, 8, ["locale", "selectData", "value"])
                  ])
                ]),
                _createVNode(_component_Select, {
                  name: "countries",
                  label: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.COUNTRIES')}`,
                  target: "countries",
                  multiple: true,
                  countries: _ctx.taxRuleData.countries,
                  "onUpdate:countries": _cache[5] || (_cache[5] = ($event: any) => (_ctx.taxRuleData.countries = $event)),
                  requiredMsg: `${_ctx.$t('message.COUNTRY')} ${_ctx.$t('message.IS_REQUIRED')}`,
                  required: true,
                  selectData: _ctx.countries,
                  value: _ctx.taxRuleData.countries
                }, null, 8, ["label", "countries", "requiredMsg", "selectData", "value"]),
                _createVNode(_component_Select, {
                  name: "tax_id",
                  label: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.TAX')}`,
                  target: "tax_id",
                  callEmit: true,
                  tax_id: _ctx.taxRuleData.tax_id,
                  "onUpdate:tax_id": _cache[6] || (_cache[6] = ($event: any) => (_ctx.taxRuleData.tax_id = $event)),
                  requiredMsg: `${_ctx.$t('message.TAX')} ${_ctx.$t('message.IS_REQUIRED')}`,
                  required: true,
                  selectData: _ctx.taxes,
                  value: _ctx.taxRuleData.tax_id,
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeTax(_ctx.taxRuleData.tax_id)))
                }, null, 8, ["label", "tax_id", "requiredMsg", "selectData", "value"]),
                (_ctx.show_tax_info)
                  ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.show_tax_info[0], (info, index) => {
                          return (_openBlock(), _createBlock(_component_el_col, {
                            span: 12,
                            key: index,
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_11, [
                                _createVNode("label", _hoisted_12, [
                                  _createVNode("span", _hoisted_13, [
                                    _createVNode("span", _hoisted_14, [
                                      _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t(index)), 1),
                                      _createVNode("span", _hoisted_16, _toDisplayString(info), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("button", _hoisted_18, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}